import styled from 'styled-components';
import React from 'react';
import { TestimonialCard, TestimonialCardProps } from '@trevor/ui-components';
import {
  TestimonialBradCuremint,
  TestimonialStephGoodtime,
  TestimonialSarahRoofr,
} from '@/images';

const TestimonialListContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: var(--spacing-xl);
  width: 100%;
`;

const testimonialItems: TestimonialCardProps[] = [
  {
    name: 'Steph',
    image: TestimonialStephGoodtime,
    role: 'Chief of Staff @ Kindred',
    message:
      'It’s the first tool I’ve seen that can help my non-technical peers jump into data!',
  },
  {
    name: 'Brad',
    image: TestimonialBradCuremint,
    role: 'Customer Success @ Curemint',
    message: 'We freaking love this tool, it has changed the game for us!',
  },
  {
    name: 'Sarah',
    image: TestimonialSarahRoofr,
    role: 'Ops @ Roofr',
    message:
      "We love the platform's plug and play method for creating reports and pulling data… A breeze!",
  },
];

export const TestimonialList = () => {
  return (
    <TestimonialListContainer>
      {testimonialItems.map((testimonial) => (
        <TestimonialCard key={`${testimonial.role}`} {...testimonial} />
      ))}
    </TestimonialListContainer>
  );
};
